import Vue from 'vue';
import Vuex from 'vuex';
import { GETTERS } from './constants';

const getters = {
    getUserInitials: (state) => state.userData.initials,
    getUserDepartment: (state) => state.userData.department,
    getHeaderData: (state) => {
        return state.headerData;
    },
    getShipmentSystem: (state) => {
        return state.shipmentSystem;
    },
    getVisibleUserBranches(state) {
        return state.visibleBranches;
    },
    getCompanies: (state) => {
        return state.companies;
    },
    getCustomsFreeZones: (state) => {
        return state.customsFreeZones;
    },
    getExportReasons: (state) => {
        return state.exportReasons;
    },
    getCountries: (state) => {
        return state.countries.sort((a, b) => a.countryCode.localeCompare(b.countryCode));
        },
    getCurrencies: (state) => {
        return state.currencies;
    },
    getUserData: (state) => {
        return state.userData;
    },
    getUserBranch: (state) => {
        return state.userBranch;
    },
    getListOfIncoterms(state) {
        return state.incoterms;
    },
    isTestMode(state) {
        return state.userData.testMode;
    },
    isCustomer(state) {
        let roles = state.userData.assignedRoles;

        let isCustomer = !roles.includes('Administrator') && !roles.includes('SuperUser');

        return isCustomer;
    },
    isAdminOrSuperUser(state) {
        let roles = state.userData.assignedRoles;

        let isAdminOrSuperUser = roles.includes('Administrator') || roles.includes('SuperUser');

        return isAdminOrSuperUser;
    },
    isFinanceUser(state) {
        let roles = state.userData.assignedRoles;

        let isFinanceUser = roles.includes('Finance') ;

        return isFinanceUser;
    },
    getBaseUrl(state, getters) {
        let shipmentSystem = getters.getShipmentSystemCountryCode;

        if (process.env.NODE_ENV === 'production') {
            return 'https://webbooking.yoyoglobal.com/' + shipmentSystem;
        }

        if (process.env.NODE_ENV === 'development') {
            return 'http://qa-azure.yoyoglobal.' + shipmentSystem;
        }
    },
    getListOfTransportProducts(state) {
        return state.transportProducts;
    },
    getCompanyAccounts: (state) => {
        const companyAccount = state.companyAccounts;
        return companyAccount;
    },
    
    getShipmentId(state) {
        return state.shipmentId;
    },
    getLinkId(state) {
        return state.linkId;
    },
    [GETTERS.CORE.IS_US_SYSTEM](state) {
        return state.shipmentSystem === 'YOYOUnitedStates';
    },
    getShipmentSystemCountryCode(state) {
        if (!state.shipmentSystems) {

            return null;
        }

        let countryCode = state.shipmentSystems[state.shipmentSystem];

        return countryCode;
    },
    isSystemInitialized(state) {
        return state.initialized;
    },
};
export default getters;
